<div class="toast-container" *ngIf="hasToasts">
    <div class="toast-queue">
        <div *ngFor="let toast of toasts" class="toast" >
            <span [ngClass]="toast.type"></span>
            <p class="display-text --small ">{{ toast.message }}</p>
            <button class="toast-close" (click)="closeToast(toast.id!)" aria-label="Fechar toast">
                ×
            </button>
        </div>
    </div>
</div>